// extracted by mini-css-extract-plugin
export default {"tab_warning":"common_tab_warning__uNFzt"};